<router-outlet
  [class]="translationService.activeLang().code"
  appConsoleWarning
  (activate)="moveScrollToTop()" />
